import React, { Component } from "react";
import ReactRoundedImage from "react-rounded-image";
import logo from "../../assets/img/brand/wizmen.png";
import FolsomLogo from "../../assets/img/FolsomLogo.png";
import { Col, Row, Container, FormGroup, Input, Label } from "reactstrap";
import { baseurl } from "../../baseurl.js";
import { headers, companyId, username, token } from "../../utils/variables";
import { Redirect } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Responseloader from "./ShortCutComponents/ResponseLoader";
import "./purchasePrintscss.css";
import { getItemQtyAmt } from "../../Helper.js";

var thisContex;
// var token = localStorage.getItem("token");
// var username = localStorage.getItem("username");
var UserName = localStorage.getItem("firstName");
// var token = localStorage.getItem("token");
// var companyId = localStorage.getItem("companyId");
var companylog = localStorage.getItem("profile_pic");
var companyName = localStorage.getItem("companyName");
var saleTaxGroup = localStorage.getItem("saleTaxGroup");
const currentDateTime = moment().format("DD-MM-YYYY hh:mm A");
const userEmail = localStorage.getItem("username") || "user@example.com";
let companySym;
// let companySym = `${baseurl}/getImages/companyLogoImg/?fileName=${companylog}`;
/////////////////////////////-------------------ClassComponents Start Here----------///////////////////////////
class PrintView extends Component {
  constructor(props) {
    super(props);
    console.log("props :>> ", props);
    let tempLogedIn = false;
    //////////////------------Token for Login prepose True and False Condition----------///////////////////////
    if (token != null) {
      tempLogedIn = true;
    }
    let propInvoiceId = this.props?.location?.state?.id || this.props?.id;
    let incomingPrefix =
      this.props.headerPrefix || this.props?.location?.state?.headerPrefix;
    // let propInvoiceId = 316;
    propInvoiceId = propInvoiceId ? propInvoiceId : -1;
    console.log("this.prop", this.props);
    console.log("this.prop", this.props?.location?.state?.headerPrefix);
    //////////////-------Components this States here to use in only Class Components ------///////////////////////
    this.state = {
      logInStatus: tempLogedIn,
      goBackUrl: this.props?.location?.pathname || "/OverviewInvoice",
      invoiceNo: "",
      transType: "",
      remarks: "",
      poNumber: "",
      issueDate: "",
      dueDate: "",
      companyName: companyName,
      clientName: "",
      viYearMake: "",
      zipCode: "",
      viModel: "",
      licenseNo: "",
      ExpenseDesc: "",
      vehicleIdNo: "",
      viMileage: "",
      city: "",
      tireFee: "",
      state: "",
      loadingResponce: false,
      setNextPrintPageFooter: false,
      setFooterData: [],
      labour: "",
      TireFee: "",
      TireDispossal: "",
      headerPrefix:
        this.props?.location?.state?.headerPrefix === "NOT GRN OR PO"
          ? "Invoice"
          : incomingPrefix,
      total_fet: 0,
      zip: "",
      disTotalItems: -1,
      sub_Amount_total_items: -1,
      totalQty: -1,
      total_Amount: -1,
      total_btAmount: -1,
      invoiceId: propInvoiceId,
      downloadLink: null,
      dynamicColumns: [],
    };
    thisContex = this;
    companySym = `${baseurl}/getImages/labelCard/?fileName=${companylog}`;
  }
  componentDidMount() {
    let Id = this.props?.location?.state?.id || this.props?.id;

    if (this.props?.authCheck) {
      this.getAuthPrintCall();
    } else {
      if (Id > 0) {
        this.getPrintCall();
      } else {
        this.goBackToInvoice();
      }
    }
  }
  downloadInvoice() {
    const element = document.getElementById("pdfContent");
  }

  convertToCurrency(param_number) {
    return param_number !== 0 && param_number !== null && param_number > 0
      ? Number(
          param_number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        )?.toFixed(2)
      : 0;
  }
  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      // Run your reload logic here
      this.getAuthPrintCall(); // or any reload function
    }
  }
  getFooterDataWithId = (id, dataLength) => {
    thisContex.setState({ loadingResponce: true });
    return axios
      .post(
        `${baseurl}/masterData/getDocFooterSetupId`,
        { id, companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let response = res.data.data[0];
        console.log("hhhhh", response);
        let label;
        if (response.page_size === "F") {
          label = "Full";
        } else {
          label = "Half";
        }
        const formValuesFooterData = [];

        if (response.desc1 !== null) {
          formValuesFooterData.push({
            desc: response.desc1,
            enteredBy: response.Ent_by_1,
          });
        }
        if (response.desc_2 !== null) {
          formValuesFooterData.push({
            desc: response.desc_2,
            enteredBy: response.Ent_by_2,
          });
        }
        if (response.desc_3 !== null) {
          formValuesFooterData.push({
            desc: response.desc_3,
            enteredBy: response.Ent_by_3,
          });
        }
        if (response.desc_4 !== null) {
          formValuesFooterData.push({
            desc: response.desc_4,
            enteredBy: response.Ent_by_4,
          });
        }
        if (response.desc_5 !== null) {
          formValuesFooterData.push({
            desc: response.desc_5,
            enteredBy: response.Ent_by_5,
          });
        }
        if (response.desc_6 !== null) {
          formValuesFooterData.push({
            desc: response.desc_6,
            enteredBy: response.Ent_by_6,
          });
        }
        console.log("hhhhh>", formValuesFooterData);
        if (formValuesFooterData.length > 3 && dataLength > 25) {
          thisContex.setState({ setNextPrintPageFooter: false });
        } else {
          thisContex.setState({ setNextPrintPageFooter: false });
        }
        thisContex.setState({ setFooterData: formValuesFooterData });
        return formValuesFooterData.length;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        thisContex.setState({ loadingResponce: false });
      });
  };
  getPrintCall() {
    let invLable;
    axios
      .post(`${baseurl}/auth/getCompany`, {
        username: username,
      })
      .then((response) => {
        var data = response.data.data;

        for (let index = 0; index < data.length; index++) {
          //  console.log('data :  >> ', data  , data[index].COMPANY_ID , data[index].LABEL , data[index].COMPANY_ID == companyId);
          if (data[index]?.COMPANY_ID == companyId)
            invLable = data[index]?.LABEL;
        }
        console.log("invLable......", invLable, companylog);
        companySym = `${baseurl}/getImages/labelCard/?fileName=${invLable}`;
      })
      .catch((error) => {
        console.log(error);
      });
    const { state } = this.props?.location;

    // let invoiceId = 7;
    if (this.state.invoiceId !== -1) {
      thisContex.setState({ loadingResponce: true }); //AHMAD

      //   if (state?.printType === "Purchase") {
      let endPoint =
        state?.headerPrefix === "Purchase Order"
          ? "getPrintPurchaseOrderView"
          : state?.headerPrefix === "GOODS RECEIPT NOTE"
          ? "getGrnPrintView"
          : state?.headerPrefix === "Sale" ||
            state?.headerPrefix === "Invoice Draft" ||
            state?.headerPrefix === "Sale Return"
          ? "getSalesPrint"
          : state?.headerPrefix === "Sale Order"
          ? "getSalesOrderPrint"
          : state?.headerPrefix === "Item Adjusment"
          ? "getItemAdjustmentPrint"
          : state?.headerPrefix === "Production Note"
          ? "getProductionNotePrint"
          : "getPrintPurchaseView";
      // alert(endPoint);
      axios
        .post(
          `${baseurl}/masterData/${endPoint}`,
          {
            username,
            invoiceId: state?.id,
            companyId,
          },
          headers
        )
        .then(async function (response) {
          let res_mt = response.data.data[0];
          let res_det = response.data.data1;
          let dataExpReb = response.data.dataExpReb;
          if (state?.headerPrefix === "Production Note") {
            let totalQty = 0;
            let total_Amount = 0;
            let total_btAmount = 0;
            let discount = 0;
            let invoiceNo = res_mt?.["prod_no"];
            let transType = res_mt?.["transactionType"];
            let invBookId = res_mt?.["INV_BOOK_ID"];
            // let poNumber = res_mt?.["INVOICE_REF_NO"];
            let issueDate = res_mt?.["prod_date"];
            // let dueDate = res_mt?.["dueDate"];
            let remarks = res_mt?.["remarks"];
            // let city = res_mt?.["customer_city"];
            // let clientName = res_mt?.["Client_Name"];
            // let totalsalesTax = 0;
            // let totalReceived = 0;
            // let totalAccepted = 0;
            // let totalRejected = 0;
            let ExpenseDesc = res_det[0]?.["Expense_Desc"];
            let Item_Desc_Lov = res_det[0]?.["prod_item_desc"];
            let acct_name = res_det[0]?.["acct_name"];
            // let address = res_mt?.["supplierAdress"];
            // let email = res_mt?.["email"];
            // let phone = res_mt?.["phone"];
            // let CURRENCY_DESC = res_mt?.["CURRENCY_DESC"];
            // let company_no = res_mt?.["company_no"];
            let dynamicInvMessage =
              state?.headerPrefix === "Item Adjusment" ||
              state?.headerPrefix === "Production Note"
                ? " "
                : state?.headerPrefix === "Sale" // : "Purchase";
                ? "Invoice"
                : "";
            // let state = res_mt?.["state_label"];
            let specificMsg =
              state?.headerPrefix === "Item Adjusment" ||
              state?.headerPrefix === "Production Note"
                ? "Doc"
                : "";

            for (let index = 0; index < res_det.length; index++) {
              //   sub_Amount_total_items += res_det[index].TC_AMOUNT;
              // totalsalesTax += res_det[index].item_sale_tax_amount;
              // discount += res_det[index].item_discount;
              // total_Amount += res_det[index].at_amount;
              total_btAmount += res_det[index].standard_amount;

              // totalReceived += res_det[index]?.item_qty;
              // totalAccepted += res_det[index]?.item_accepted_qty;
              // totalRejected += res_det[index]?.item_rejected_qty;
            }
            if (invBookId) {
              thisContex.getFooterDataWithId(
                res_mt?.["INV_BOOK_ID"],
                res_det.length
              );
            }
            thisContex.setState({
              loadingResponce: false,
              invoiceNo: invoiceNo,
              transType: transType,
              // poNumber: poNumber,
              issueDate: moment(issueDate).format("DD-MM-YYYY"),
              // dueDate: moment(dueDate).format("DD-MM-YYYY"),
              // clientName: clientName,
              res_det: res_det,
              ExpenseDesc,
              Item_Desc_Lov,
              acct_name,
              // total_Amount: total_Amount,
              total_btAmount: total_btAmount,
              // discount,
              // totalsalesTax,
              // totalReceived,
              // totalAccepted,
              // totalRejected,
              // address,
              remarks,
              // email,
              // city,
              // phone,
              // company_no,
              // CURRENCY_DESC,
              invBookId,
              dynamicInvMessage,
              specificMsg,
              state,
            });
          } else {
            let total_Amount = 0;
            let totalQty = 0;
            let total_btAmount = 0;
            let discount = 0;
            let invoiceNo = res_mt?.["DOCUMENT_NO"];
            let invBookId = res_mt?.["INV_BOOK_ID"];
            let poNumber = res_mt?.["INVOICE_REF_NO"];
            let issueDate = res_mt?.["issueDate"];
            let dueDate = res_mt?.["dueDate"];
            let inv_ref_no = res_mt?.["inv_ref_no"];
            let remarks = res_mt?.["remarks"];
            let city = res_mt?.["customer_city"];
            let clientName = res_mt?.["Client_Name"];
            let branchName = res_mt?.["sub_inv_desc"];
            let totalsalesTax = 0;
            let totalReceived = 0;
            let totalAccepted = 0;
            let totalRejected = 0;
            let totalExpRebAmt = 0;
            let ExpenseDesc = res_det[0]?.["Expense_Desc"];
            let Item_Desc_Lov = res_det[0]?.["Item_Desc_Lov"];
            let acct_name = res_det[0]?.["acct_name"];
            let address = res_mt?.["supplierAdress"];
            let email = res_mt?.["email"];
            let phone = res_mt?.["phone"];
            let CURRENCY_DESC = res_mt?.["CURRENCY_DESC"];
            let company_no = res_mt?.["company_no"];
            let dynamicInvMessage =
              state?.headerPrefix === "Item Adjusment" ||
              state?.headerPrefix === "Production Note" ||
              state?.headerPrefix === "GOODS RECEIPT NOTE"
                ? ""
                : state?.headerPrefix === "Sale"
                ? "Invoice"
                : "";
            // let state = res_mt?.["state_label"];
            let specificMsg =
              state?.headerPrefix === "Item Adjusment" ||
              state?.headerPrefix === "Production Note" ||
              state?.headerPrefix === "GOODS RECEIPT NOTE"
                ? "Doc"
                : "";

            for (let index = 0; index < res_det.length; index++) {
              //   sub_Amount_total_items += res_det[index].TC_AMOUNT;
              totalsalesTax += res_det[index].item_sale_tax_amount;
              discount += res_det[index].item_discount;
              total_Amount += res_det[index].at_amount;
              totalQty += res_det[index].item_qty;
              total_btAmount += res_det[index].item_bt_amount;

              totalReceived += res_det[index]?.item_qty;
              totalAccepted += res_det[index]?.item_accepted_qty;
              totalRejected += res_det[index]?.item_rejected_qty;
              let stockQty = await getItemQtyAmt(
                res_det[index].ITEM_ID,
                res_det[index].sub_inv_id,
                res_det[index].issueDate
              );
              res_det[index]["last_purch_rate"] = stockQty[2];
            }
            for (let index = 0; index < dataExpReb?.length; index++) {
              //   sub_Amount_total_items += dataExpReb[index].TC_AMOUNT;
              totalExpRebAmt += dataExpReb[index]?.fc_amount;
            }

            let invoiceTotal = total_Amount + totalExpRebAmt;
            if (invBookId) {
              thisContex.getFooterDataWithId(
                res_mt?.["INV_BOOK_ID"],
                res_det.length
              );
            }
            thisContex.setState({
              loadingResponce: false,
              invoiceNo: invoiceNo,
              poNumber: poNumber,
              issueDate: moment(issueDate).format("DD-MM-YYYY"),
              dueDate: moment(dueDate).format("DD-MM-YYYY"),
              inv_ref_no: inv_ref_no,
              clientName: clientName,
              branchName: branchName,
              res_det: res_det,
              dataExpReb: dataExpReb,
              ExpenseDesc,
              Item_Desc_Lov,
              acct_name,
              totalQty: totalQty,
              total_Amount: total_Amount,
              total_btAmount: total_btAmount,
              discount,
              totalsalesTax,
              totalReceived,
              totalAccepted,
              totalRejected,
              totalExpRebAmt,
              invoiceTotal,
              address,
              remarks,
              email,
              city,
              phone,
              company_no,
              CURRENCY_DESC,
              invBookId,
              dynamicInvMessage,
              specificMsg,
              state,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
  getAuthPrintCall() {
    // let invLable;
    // axios
    //   .post(`${baseurl}/auth/getCompany`, {
    //     username: username,
    //   })
    //   .then((response) => {
    //     var data = response.data.data;

    //     for (let index = 0; index < data.length; index++) {
    //       //  console.log('data :  >> ', data  , data[index].COMPANY_ID , data[index].LABEL , data[index].COMPANY_ID == companyId);
    //       if (data[index]?.COMPANY_ID == companyId)
    //         invLable = data[index]?.LABEL;
    //     }
    //     console.log("invLable......", invLable, companylog);
    //     companySym = `${baseurl}/getImages/labelCard/?fileName=${invLable}`;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    const { headerPrefix, id, inv_book_id } = this.props;

    // let invoiceId = 7;
    if (this.state.invoiceId !== -1) {
      thisContex.setState({ loadingResponce: true }); //AHMAD

      //   if (state?.printType === "Purchase") {
      let endPoint =
        headerPrefix === "Purchase Order"
          ? "getPrintPurchaseOrderView"
          : headerPrefix === "GOODS RECEIPT NOTE"
          ? "getGrnPrintView"
          : headerPrefix === "Sale" ||
            headerPrefix === "Invoice Draft" ||
            headerPrefix === "Sale Return"
          ? "getSalesPrint"
          : headerPrefix === "Sale Order"
          ? "getSalesOrderPrint"
          : headerPrefix === "Item Adjusment"
          ? "getItemAdjustmentPrint"
          : headerPrefix === "Production Note"
          ? "getProductionNotePrint"
          : headerPrefix === "Auth Print View"
          ? "getAuthPrintView"
          : "getPrintPurchaseView";
      // alert(endPoint);
      console.log("endpoint", endPoint);
      axios
        .post(
          `${baseurl}/masterData/${endPoint}`,
          {
            username,
            invoiceId: id,
            companyId,
            inv_book_id: inv_book_id,
          },
          headers
        )
        .then(function (response) {
          let res_mt = response.data.header;
          let res_det = response.data.details || response.data.detail || []; // Handle naming mismatch
          let dynamicColumns = response.data.columns || [];
          let invoiceNo = res_mt?.["DOCUMENT_NO"] || res_mt?.["doc_no"]; // Handle dynamic naming
          if (headerPrefix === "Production Note") {
            let total_Amount = 0;
            let totalQty = 0;
            let total_btAmount = 0;
            let discount = 0;
            let invoiceNo = res_mt?.["prod_no"];
            let transType = res_mt?.["transactionType"];
            let invBookId = res_mt?.["INV_BOOK_ID"];
            // let poNumber = res_mt?.["INVOICE_REF_NO"];
            let issueDate = res_mt?.["prod_date"];
            // let dueDate = res_mt?.["dueDate"];
            let remarks = res_mt?.["remarks"];
            // let city = res_mt?.["customer_city"];
            // let clientName = res_mt?.["Client_Name"];
            // let totalsalesTax = 0;
            // let totalReceived = 0;
            // let totalAccepted = 0;
            // let totalRejected = 0;
            let ExpenseDesc = res_det[0]?.["Expense_Desc"];
            let Item_Desc_Lov = res_det[0]?.["prod_item_desc"];
            let acct_name = res_det[0]?.["acct_name"];
            // let address = res_mt?.["supplierAdress"];
            // let email = res_mt?.["email"];
            // let phone = res_mt?.["phone"];
            // let CURRENCY_DESC = res_mt?.["CURRENCY_DESC"];
            // let company_no = res_mt?.["company_no"];
            let dynamicInvMessage =
              headerPrefix === "Item Adjusment" ||
              headerPrefix === "Production Note"
                ? " "
                : headerPrefix === "Sale"
                ? "Invocie"
                : "";
            // let state = res_mt?.["state_label"];
            let specificMsg =
              headerPrefix === "Item Adjusment" ||
              headerPrefix === "Production Note"
                ? "Doc"
                : "";

            for (let index = 0; index < res_det.length; index++) {
              //   sub_Amount_total_items += res_det[index].TC_AMOUNT;
              // totalsalesTax += res_det[index].item_sale_tax_amount;
              // discount += res_det[index].item_discount;
              // total_Amount += res_det[index].at_amount;
              total_btAmount += res_det[index].standard_amount;

              // totalReceived += res_det[index]?.item_qty;
              // totalAccepted += res_det[index]?.item_accepted_qty;
              // totalRejected += res_det[index]?.item_rejected_qty;
            }
            // if (invBookId) {
            //   thisContex.getFooterDataWithId(
            //     res_mt?.["INV_BOOK_ID"],
            //     res_det.length
            //   );
            // }
            thisContex.setState({
              loadingResponce: false,
              invoiceNo: invoiceNo,
              transType: transType,
              // poNumber: poNumber,
              issueDate: moment(issueDate).format("DD-MM-YYYY"),
              // dueDate: moment(dueDate).format("DD-MM-YYYY"),
              // clientName: clientName,
              res_det: res_det,
              ExpenseDesc,
              Item_Desc_Lov,
              acct_name,
              // total_Amount: total_Amount,
              total_btAmount: total_btAmount,
              // discount,
              // totalsalesTax,
              // totalReceived,
              // totalAccepted,
              // totalRejected,
              // address,
              remarks,
              // email,
              // city,
              // phone,
              // company_no,
              // CURRENCY_DESC,
              invBookId,
              dynamicInvMessage,
              specificMsg,
              // state,
            });
          } else {
            let total_Amount = 0;
            let totalQty = 0;
            let total_btAmount = 0;
            let discount = 0;
            let invoiceNo = res_mt?.["DOCUMENT_NO"];
            let invBookId = res_mt?.["INV_BOOK_ID"];
            let poNumber = res_mt?.["INVOICE_REF_NO"];
            let issueDate = res_mt?.["issueDate"];
            let dueDate = res_mt?.["dueDate"];
            let inv_ref_no = res_mt?.["inv_ref_no"];
            let remarks = res_mt?.["remarks"];
            let city = res_mt?.["customer_city"];
            let clientName = res_mt?.["Client_Name"];
            let branchName = res_mt?.["sub_inv_desc"];

            let totalsalesTax = 0;
            let totalReceived = 0;
            let totalAccepted = 0;
            let totalRejected = 0;
            let ExpenseDesc = res_det[0]?.["Expense_Desc"];
            let Item_Desc_Lov = res_det[0]?.["Item_Desc_Lov"];
            let acct_name = res_det[0]?.["acct_name"];
            let address = res_mt?.["supplierAdress"];
            let email = res_mt?.["email"];
            let phone = res_mt?.["phone"];
            let CURRENCY_DESC = res_mt?.["CURRENCY_DESC"];
            let company_no = res_mt?.["company_no"];
            let dynamicInvMessage =
              headerPrefix === "Item Adjusment" ||
              headerPrefix === "Production Note" ||
              headerPrefix === "GOODS RECEIPT NOTE"
                ? ""
                : headerPrefix === "Sale"
                ? "Invoice"
                : "";
            // let state = res_mt?.["state_label"];
            let specificMsg =
              headerPrefix === "Item Adjusment" ||
              headerPrefix === "Production Note" ||
              headerPrefix === "GOODS RECEIPT NOTE"
                ? "Doc"
                : "";

            for (let index = 0; index < res_det.length; index++) {
              //   sub_Amount_total_items += res_det[index].TC_AMOUNT;
              totalsalesTax += res_det[index].item_sale_tax_amount;
              discount += res_det[index].item_discount;
              total_Amount += res_det[index].at_amount;
              totalQty += res_det[index].item_qty;
              total_btAmount += res_det[index].item_bt_amount;

              totalReceived += res_det[index]?.item_qty;
              totalAccepted += res_det[index]?.item_accepted_qty;
              totalRejected += res_det[index]?.item_rejected_qty;
            }
            // if (invBookId) {
            //   thisContex.getFooterDataWithId(
            //     res_mt?.["INV_BOOK_ID"],
            //     res_det.length
            //   );
            // }
            thisContex.setState({
              loadingResponce: false,
              invoiceNo: invoiceNo,
              poNumber: poNumber,
              issueDate: moment(issueDate).format("DD-MM-YYYY"),
              dueDate: moment(dueDate).format("DD-MM-YYYY"),
              inv_ref_no: inv_ref_no,
              clientName: clientName,
              branchName: branchName,
              res_det: res_det,
              ExpenseDesc,
              Item_Desc_Lov,
              acct_name,
              total_Amount: total_Amount,
              totalQty: totalQty,
              total_btAmount: total_btAmount,
              discount,
              totalsalesTax,
              totalReceived,
              totalAccepted,
              totalRejected,
              address,
              remarks,
              email,
              city,
              phone,
              company_no,
              CURRENCY_DESC,
              invBookId,
              dynamicInvMessage,
              specificMsg,
              dynamicColumns: dynamicColumns,
              // state,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          thisContex.setState({ loadingResponce: false });
        });
    }
  }
  goBackToInvoice() {
    console.log(
      "ridirect............",
      this.props?.location?.state?.updateCheck
    );
    // console.log("ridirect............", this.props?.location?.state);
    const state = this.props?.location?.state;
    // console.log("state............", state);
    const redirectPath = state?.pathname || state?.url || "/Dashboard";
    this.setState({
      goBack: true,
      redirectPath: redirectPath,
    });
  }

  render() {
    const {
      invoiceId,
      logInStatus,
      invoiceNo,
      goBackUrl,
      transType,
      poNumber,
      issueDate,
      dueDate,
      companyName,
      clientName,
      inv_ref_no,
      branchName,
      total_Amount,
      totalQty,
      total_btAmount,
      totalsalesTax,
      totalReceived,
      totalAccepted,
      totalExpRebAmt,
      invoiceTotal,
      totalRejected,
      discount,
      saleTaxAmount,
      salesTax,
      phone,
      email,
      ExpenseDesc,
      Item_Desc_Lov,
      acct_name,
      remarks,
      city,
      state,
      company_no,
      address,
      goBack,
      CURRENCY_DESC,
      dynamicInvMessage,
      headerPrefix,
      loadingResponce,
      specificMsg,
    } = this.state;
    if (!logInStatus) return <Redirect to="/login" />;
    else if (loadingResponce) {
      return <Responseloader />;
    } else if (goBack) {
      return (
        <Redirect
          // to="/CreativeInvoice"
          push
          to={{
            pathname:
              this.props?.location?.state?.url ||
              this.props?.location?.pathname,
            state: {
              id: this.state.invoiceId,
              updateCheck: this.props?.location?.state?.updateCheck, //AHMAD
              // updateCheck: 2, //AHMAD
            },
          }}
        />
      );
    } else if (invoiceId !== -1) {
      return (
        <div className="pdfContent-Print" id="pdfContent-Print">
          <Row className="app-body-Invoice bg-white">
            <Col xs="12">
              <Row className="">
                <Col xs="4" className="px-5 row">
                  <ReactRoundedImage
                    className="ReactRoundedImage"
                    image={companySym}
                    roundedColor="#321124"
                    imageWidth="50"
                    imageHeight="45"
                    roundedSize="4"
                  />
                  <h1>
                    {companyName === "Dollar Junction"
                      ? "Dollar Junction"
                      : companyName}
                  </h1>
                </Col>
                <Col xs="5">
                  {" "}
                  <h2 className="text-center">
                    <u>
                      {headerPrefix} {dynamicInvMessage}
                    </u>
                  </h2>{" "}
                </Col>
                {this.props?.authCheck ? null : (
                  <Col xs="3" className="px-4">
                    <div style={{ textAlign: "end" }}>
                      <button
                        className="btn btn-primary mx-2"
                        id="printPageButton"
                        onClick={() => {
                          window.print();
                        }}
                      >
                        Print to PDF!
                      </button>
                      <button
                        className="btn btn-primary m-1"
                        id="printPageButton"
                        onClick={() => {
                          this.goBackToInvoice();
                        }}
                      >
                        Back
                      </button>
                    </div>{" "}
                  </Col>
                )}
                <Col xs="12" className="px-5 row">
                  <h1>{branchName ? `(${branchName})` : ""}</h1>
                </Col>
              </Row>
              <br></br>
              <hr
                style={{
                  marginTop: "-0.5rem",
                  border: "1px solid Light gray",
                }}
              />
              {state?.headerPrefix === "Item Adjusment" ? (
                <Row className="px-4 display-flex flex">
                  <Col
                    xs="6"
                    className="px-4"
                    style={{
                      marginLeft: "0%", // Adjust the horizontal position as needed
                      marginTop: "-1%",
                      padding: "5px", // Adjust the vertical position as needed
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start", // Align all items to the start of the column
                    }}
                  >
                    {/* Invoice Message and Number */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        {specificMsg ? specificMsg : dynamicInvMessage} No:
                      </h4>
                      <span style={{ marginLeft: "0px" }}>
                        <h5>{invoiceNo}</h5>
                      </span>
                    </div>
                  </Col>
                  <Col
                    xs="6"
                    className="px-4"
                    style={{
                      marginLeft: "76%", // Adjust the horizontal position as needed
                      marginTop: "-5%", // Adjust the vertical position as needed
                      display: "flex",
                      padding: "5px",
                      flexDirection: "column",
                      alignItems: "flex-start", // Align all items to the start of the column
                    }}
                  >
                    {/* Invoice Message and Number */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        Issue Date:
                      </h4>
                      <span style={{ marginLeft: "4px" }}>
                        <h5>{issueDate}</h5>
                      </span>
                    </div>
                  </Col>
                  <Col
                    xs="12"
                    className="px-4"
                    style={{
                      marginLeft: "0%", // Adjust the horizontal position as needed
                      marginTop: "-1%",
                      padding: "5px", // Adjust the vertical position as needed
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start", // Align all items to the start of the column
                    }}
                  >
                    {/* Invoice Message and Number */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        Remarks:
                      </h4>
                      <span style={{ marginLeft: "0px" }}>
                        <h5>{remarks}</h5>
                      </span>
                    </div>
                  </Col>
                </Row>
              ) : state?.headerPrefix === "Production Note" ? (
                <Row className="px-4 display-flex flex">
                  <Col
                    xs="4"
                    className="px-4"
                    style={{
                      marginLeft: "0%", // Adjust the horizontal position as needed
                      marginTop: "-1%",
                      padding: "5px", // Adjust the vertical position as needed
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start", // Align all items to the start of the column
                    }}
                  >
                    {/* Invoice Message and Number */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        {specificMsg ? specificMsg : dynamicInvMessage} No:
                      </h4>
                      <span style={{ marginLeft: "0px" }}>
                        <h5>{invoiceNo}</h5>
                      </span>
                    </div>
                  </Col>
                  <Col
                    xs="4"
                    className="px-4"
                    style={{
                      marginLeft: "0%", // Adjust the horizontal position as needed
                      marginTop: "-1%", // Adjust the vertical position as needed
                      display: "flex",
                      padding: "5px",
                      flexDirection: "column",
                      alignItems: "flex-start", // Align all items to the start of the column
                    }}
                  >
                    {/* Invoice Message and Number */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        Issue Date:
                      </h4>
                      <span style={{ marginLeft: "4px" }}>
                        <h5>{issueDate}</h5>
                      </span>
                    </div>
                  </Col>
                  <Col
                    xs="4"
                    className="px-4"
                    style={{
                      marginLeft: "0%", // Adjust the horizontal position as needed
                      marginTop: "-1%", // Adjust the vertical position as needed
                      display: "flex",
                      padding: "5px",
                      flexDirection: "column",
                      alignItems: "flex-end", // Align all items to the start of the column
                    }}
                  >
                    {/* Invoice Message and Number */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        Transaction Type:
                      </h4>
                      <span style={{ marginLeft: "4px" }}>
                        <h5>{transType}</h5>
                      </span>
                    </div>
                  </Col>
                  <Col
                    xs="12"
                    className="px-4"
                    style={{
                      marginLeft: "0%", // Adjust the horizontal position as needed
                      marginTop: "-1%",
                      padding: "5px", // Adjust the vertical position as needed
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start", // Align all items to the start of the column
                    }}
                  >
                    {/* Invoice Message and Number */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        Remarks:
                      </h4>
                      <span style={{ marginLeft: "0px" }}>
                        <h5>{remarks}</h5>
                      </span>
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row className="px-4 display-flex flex">
                  <Col
                    xs="6"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      marginTop: "2%",
                      marginBottom: "2%",
                    }}
                  >
                    <h2>
                      <b>{clientName}</b>
                    </h2>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        Address:
                      </h4>
                      <span style={{ marginLeft: "10px" }}>
                        <h5>{address}</h5>
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        Phone:
                      </h4>
                      <span style={{ marginLeft: "10px" }}>
                        <h5>{phone && phone !== "undefined" ? phone : "-"}</h5>
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        E-Mail:
                      </h4>
                      <span style={{ marginLeft: "10px" }}>
                        <h5>{email && email !== "undefined" ? email : "-"}</h5>
                      </span>
                    </div>
                  </Col>
                  <Col
                    xs="6"
                    className="px-4 header-Print"
                    style={{
                      marginLeft: "76%", // Adjust the horizontal position as needed
                      marginTop: "-15.5%", // Adjust the vertical position as needed
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start", // Align all items to the start of the column
                    }}
                  >
                    {/* Invoice Message and Number */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        {specificMsg ? specificMsg : dynamicInvMessage} No:
                      </h4>
                      <span style={{ marginLeft: "0px" }}>
                        <h5>{invoiceNo}</h5>
                      </span>
                    </div>

                    {/* PO Number (conditionally rendered) */}
                    {poNumber && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          marginBottom: "8px",
                        }}
                      >
                        <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                          PO Number:
                        </h4>
                        <span style={{ marginLeft: "0px" }}>
                          <h5>{poNumber}</h5>
                        </span>
                      </div>
                    )}

                    {/* Issue Date */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "8px", minWidth: "90px" }}>
                        Inv Date:
                      </h4>
                      <span style={{ marginLeft: "4px" }}>
                        <h5>{issueDate}</h5>
                      </span>
                    </div>

                    {/* Due Date */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "8px", minWidth: "90px" }}>
                        Due Date:
                      </h4>
                      <span style={{ marginLeft: "7px" }}>
                        <h5>{dueDate}</h5>
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        Ref No:
                      </h4>
                      <span style={{ marginLeft: "7px" }}>
                        <h5>{inv_ref_no}</h5>
                      </span>
                    </div>
                  </Col>
                </Row>
              )}
              <hr
                style={{
                  border: "1px solid Light gray",
                  marginTop: "-2%",
                }}
              />
              <Row xs="12" className="px-4">
                <Col xs="12" className="">
                  {headerPrefix === "GOODS RECEIPT NOTE" ? (
                    <table style={{ width: "100%" }}>
                      <colgroup>
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "15%" }} />
                      </colgroup>

                      <thead>
                        <tr>
                          <th className="text-left">Item</th>
                          <th className="text-left">Unit</th>
                          <th
                            colSpan="3"
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            Quantity
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          <th
                            className="text-center"
                            style={{
                              borderTop: "2px solid black",
                              borderLeft: "2px solid black",
                              borderBottom: "2px solid black",
                              padding: "8px",
                            }}
                          >
                            Received
                          </th>
                          <th
                            className="text-center"
                            style={{
                              borderTop: "2px solid black",
                              borderBottom: "2px solid black",
                              padding: "8px",
                            }}
                          >
                            Accepted
                          </th>
                          <th
                            className="text-center"
                            style={{
                              borderTop: "2px solid black",
                              borderRight: "2px solid black",
                              borderBottom: "2px solid black",
                              padding: "8px",
                            }}
                          >
                            Rejected
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {this.state.res_det?.map((itm, index) => (
                          <tr key={index}>
                            <td className="text-left">{itm.item_desc}</td>
                            <td className="text-left">
                              {itm.item_unit && itm.item_unit !== "undefined"
                                ? itm.item_unit.toString()
                                : ""}
                            </td>
                            <td className="text-center">
                              {itm.item_qty
                                ?.toFixed(1) //haider bhai's request to show one decimal 13-nov-2023
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-center">
                              {itm.item_accepted_qty
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-center">
                              {itm.item_rejected_qty
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                          </tr>
                        ))}
                      </tbody>

                      <tfoot>
                        <tr>
                          <td colSpan="2">
                            <b>Total (PKR)</b>
                          </td>
                          <td className="text-center">
                            <b>
                              {totalReceived
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </b>
                          </td>
                          <td className="text-center">
                            <b>
                              {totalAccepted
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </b>
                          </td>
                          <td className="text-center">
                            <b>
                              {totalRejected
                                ?.toFixed(2)
                                ?.toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </b>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  ) : headerPrefix === "Item Adjusment" ? (
                    <table style={{ width: "100%" }}>
                      <colgroup>
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "20%" }} />
                      </colgroup>

                      <thead>
                        <tr>
                          <th className="border">Item</th>
                          <th className="border">Unit</th>
                          <th className="border text-right">Qty</th>
                          <th className="border text-right mr-1">Rate</th>
                          <th className="border text-right mr-1">Amount</th>
                          <th className="border text-center mr-1">Account</th>
                        </tr>
                      </thead>

                      <tbody>
                        {this.state.res_det?.map((itm, index) => (
                          <tr key={index}>
                            <td>{itm.item_desc}</td>
                            <td>
                              {itm.item_unit && itm.item_unit !== "undefined"
                                ? itm.item_unit.toString()
                                : ""}
                            </td>
                            <td className="text-right">
                              {itm.item_qty
                                ?.toFixed(1) //haider bhai's request to show one decimal 13-nov-2023
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right mr-1">
                              {itm.item_rate
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right">
                              {itm.item_bt_amount
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-center">{itm.NAME}</td>
                          </tr>
                        ))}
                      </tbody>

                      <tfoot>
                        <tr>
                          <td colSpan="4">
                            <b>Total (PKR)</b>
                          </td>
                          <td className="text-right">
                            <b>
                              {total_btAmount
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </b>
                          </td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </table>
                  ) : headerPrefix === "Production Note" ? (
                    <table style={{ width: "100%" }}>
                      <colgroup>
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "20%" }} />
                      </colgroup>

                      <thead>
                        <tr>
                          <th className="border">Item</th>
                          <th className="border">Unit</th>
                          <th className="border text-right">Ordered Qty</th>
                          <th className="border text-right">Produced Qty</th>
                          <th className="border text-right mr-1">Rate</th>
                          <th className="border text-right mr-1">Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {this.state.res_det?.map((itm, index) => (
                          <tr key={index}>
                            <td>{itm.prod_item_desc}</td>
                            <td>
                              {itm.prod_uom_desc &&
                              itm.prod_uom_desc !== "undefined"
                                ? itm.prod_uom_desc.toString()
                                : ""}
                            </td>
                            <td className="text-right">
                              {itm.Qty_Ordered?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right mr-1">
                              {itm.qty_produced
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right mr-1">
                              {itm.item_rate
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right">
                              {itm.item_bt_amount
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                          </tr>
                        ))}
                      </tbody>

                      <tfoot>
                        <tr>
                          <td colSpan="5">
                            <b>Total (PKR)</b>
                          </td>
                          <td className="text-right">
                            <b>
                              {total_btAmount
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </b>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  ) : headerPrefix === "Auth Print View" &&
                    this.state.dynamicColumns.length > 0 ? (
                    <table
                      bordered
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginBottom: "1rem",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            className="border text-center"
                            style={{ width: "5%", padding: "5px" }}
                          >
                            Sr #
                          </th>
                          {this.state.dynamicColumns.map((col, index) => (
                            <th
                              key={index}
                              className={`border text-center ${
                                col.isNumeric ? "text-right" : ""
                              }`}
                              style={{ padding: "5px", fontWeight: "bold" }}
                            >
                              {col.label}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.res_det?.map((itm, rowIndex) => (
                          <tr key={rowIndex} className="border-bottom">
                            <td
                              className="text-center"
                              style={{ padding: "5px" }}
                            >
                              {rowIndex + 1}
                            </td>
                            {this.state.dynamicColumns.map((col, colIndex) => (
                              <td
                                key={colIndex}
                                className={
                                  col.isNumeric ? "text-right" : "text-left"
                                }
                                style={{ padding: "5px" }}
                              >
                                {col.isNumeric &&
                                itm[col.field] !== null &&
                                itm[col.field] !== undefined
                                  ? Number(itm[col.field])
                                      .toFixed(2)
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  : itm[col.field]}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr style={{ borderTop: "2px solid black" }}>
                          <td style={{ padding: "5px" }}>
                            <b>Total</b>
                          </td>
                          {this.state.dynamicColumns.map((col, index) => {
                            if (
                              col.field.toLowerCase().includes("amount") ||
                              col.field.toLowerCase().includes("qty")
                            ) {
                              const total = this.state.res_det.reduce(
                                (acc, row) => {
                                  if (col.field === "AMOUNT") {
                                    return (
                                      acc +
                                      (parseFloat(row.AMOUNT) || 0) +
                                      (parseFloat(row.STAX_AMOUNT) || 0)
                                    );
                                  }
                                  return (
                                    acc + (parseFloat(row[col.field]) || 0)
                                  );
                                },
                                0
                              );

                              return (
                                <td
                                  key={index}
                                  className="text-right"
                                  style={{ padding: "5px" }}
                                >
                                  <b>
                                    {total
                                      .toFixed(2)
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  </b>
                                </td>
                              );
                            } else {
                              return <td key={index}></td>;
                            }
                          })}
                        </tr>
                      </tfoot>
                    </table>
                  ) : (
                    <table bordered style={{ width: "100%" }}>
                      {saleTaxGroup != 0 ? (
                        <colgroup>
                          {headerPrefix === "Sale" ||
                          headerPrefix === "Invoice Draft" ||
                          headerPrefix === "Sale Return" ? (
                            <>
                              <col style={{ width: "5%" }} />
                              <col style={{ width: "30%" }} />
                              <col style={{ width: "8%" }} /> {/* Unit */}
                              <col style={{ width: "10%" }} /> {/* Qty */}
                              <col style={{ width: "8%" }} /> {/* Rate */}
                              <col style={{ width: "12%" }} /> {/* Amt Excl */}
                              <col style={{ width: "10%" }} /> {/* Discount */}
                              <col style={{ width: "10%" }} /> {/* S.Tax */}
                              <col style={{ width: "12%" }} /> {/* Amt Incl */}
                            </>
                          ) : (
                            <>
                              <col style={{ width: "5%" }} /> {/*Sr*/}
                              <col style={{ width: "30%" }} />
                              <col style={{ width: "6%" }} /> {/* Unit */}
                              <col style={{ width: "6%" }} /> {/* Qty */}
                              <col style={{ width: "8%" }} /> {/* Rate */}
                              {companyName === "Dollar Junction" ? (
                                ""
                              ) : (
                                <col style={{ width: "8%" }} />
                              )}
                              {/* LPR */}
                              <col style={{ width: "15%" }} /> {/* Amt Excl */}
                              <col style={{ width: "5%" }} /> {/* Discount */}
                              <col style={{ width: "10%" }} /> {/* S.Tax */}
                              <col style={{ width: "20%" }} /> {/* Amt Incl */}
                            </>
                          )}
                        </colgroup>
                      ) : (
                        <colgroup>
                          <col style={{ width: "30%" }} />
                          <col style={{ width: "8%" }} /> {/* Unit */}
                          <col style={{ width: "10%" }} /> {/* Qty */}
                          <col style={{ width: "8%" }} /> {/* Rate */}
                          {companyName === "Dollar Junction" ? (
                            ""
                          ) : (
                            <col style={{ width: "8%" }} />
                          )}
                          {/* LPR */}
                          <col style={{ width: "12%" }} /> {/* Amt Excl */}
                          <col style={{ width: "10%" }} /> {/* Discount */}
                          <col style={{ width: "10%" }} /> {/* S.Tax */}
                          <col style={{ width: "12%" }} /> {/* Amt Incl */}
                        </colgroup>
                      )}

                      <thead>
                        <tr>
                          <th
                            className="border text-center"
                            style={{ width: "5%" }}
                          >
                            Sr. #
                          </th>
                          {Item_Desc_Lov ? (
                            <th className="border text-center">Item</th>
                          ) : acct_name ? (
                            <th className="border text-center">Category</th>
                          ) : (
                            <th className="border text-center">Item</th>
                          )}
                          <th className="border text-center">Unit</th>
                          <th className="border text-center">Qty</th>
                          {companyName === "Dollar Junction" ? (
                            ""
                          ) : headerPrefix === "Sale" ||
                            headerPrefix === "Invoice Draft" ||
                            headerPrefix === "Sale Return" ? null : (
                            <th
                              title="Last Purchase Rate"
                              className="border text-center"
                            >
                              LPR
                            </th>
                          )}
                          <th className="border text-center mr-1">Rate</th>

                          {saleTaxGroup === 0 || saleTaxGroup === "0" ? (
                            <th className="border text-center mr-1">Amount</th>
                          ) : (
                            <th className="border text-center">Subtotal</th>
                          )}

                          <th className="border text-center mr-1">Discount</th>

                          {saleTaxGroup != 0 ? (
                            <>
                              <th className="border text-center">Sale Tax</th>
                              <th className="border text-center">Total</th>
                            </>
                          ) : (
                            ""
                          )}
                        </tr>
                      </thead>

                      <tbody className="border-bottom">
                        {this.state.res_det?.map((itm, index) => {
                          const showLastPurchaseRate =
                            companyName !== "Dollar Junction" &&
                            headerPrefix !== "Sale" &&
                            headerPrefix !== "Invoice Draft" &&
                            headerPrefix !== "Sale Return";

                          const showTaxColumns = saleTaxGroup != 0;

                          const colSpan =
                            7 +
                            (showLastPurchaseRate ? 1 : 0) +
                            (showTaxColumns ? 2 : 0);

                          return (
                            <React.Fragment key={index}>
                              {/* Main row */}
                              <tr className="border-bottom">
                                <td className="text-center">{index + 1}</td>
                                <td>{itm.item_desc || itm.acct_name}</td>
                                <td>
                                  {itm.item_unit &&
                                  itm.item_unit !== "undefined"
                                    ? itm.item_unit.toString()
                                    : ""}
                                </td>
                                <td className="text-right">
                                  {itm.item_qty
                                    ?.toFixed(
                                      companyName === "New Eggspectation"
                                        ? 1
                                        : 2
                                    )
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>

                                {showLastPurchaseRate && (
                                  <td className="text-right mr-1 py-2 px-3">
                                    {itm.last_purch_rate
                                      ?.toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  </td>
                                )}

                                <td className="text-right mr-1 py-2 px-3">
                                  {itm.item_rate
                                    ?.toFixed(1)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>

                                <td className="text-right py-2 px-3">
                                  {itm.item_bt_amount
                                    ?.toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>

                                <td className="text-right mr-2">
                                  {itm.item_discount
                                    ?.toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>

                                {showTaxColumns && (
                                  <>
                                    <td className="text-right">
                                      {itm.item_sale_tax_amount
                                        ?.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                    <td className="text-right py-2 px-3">
                                      {itm.at_amount
                                        ?.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                  </>
                                )}
                              </tr>

                              {/* Full-width remarks row */}
                              {itm.det_remarks && (
                                <tr className="remarks-row">
                                  <td colSpan={colSpan} className="text-left">
                                    <strong>Detail Remarks:</strong>{" "}
                                    {itm.det_remarks}
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </tbody>

                      <tfoot>
                        <tr>
                          {/* Label cell */}
                          <td>
                            <b>Total (PKR)</b>
                          </td>
                          <td></td>
                          {/* Unit */}
                          <td></td>
                          {companyName === "Dollar Junction" ? (
                            <td className="text-right">
                              <b>
                                {totalQty
                                  ? Math.round(totalQty)
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  : 0}
                              </b>
                            </td>
                          ) : (
                            <td></td>
                          )}

                          {/* LPR (conditionally present) */}

                          {companyName === "Dollar Junction" ? (
                            ""
                          ) : headerPrefix === "Sale" ||
                            headerPrefix === "Invoice Draft" ||
                            headerPrefix === "Sale Return" ? null : (
                            <td></td>
                          )}

                          {/* Rate */}
                          <td></td>

                          {/* Amt Excl or Amount (we leave it blank as totals are shown below) */}
                          <td></td>

                          {/* Discount (show total in this column for both tax/non-tax cases) */}
                          <td className="text-right">
                            <b>
                              {discount
                                ?.toFixed(0)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </b>
                          </td>

                          {saleTaxGroup != 0 ? (
                            <>
                              {/* S.Tax total */}
                              <td className="text-right">
                                <b>
                                  {totalsalesTax
                                    ?.toFixed(0)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </b>
                              </td>

                              {/* Amt Incl total */}
                              <td className="text-right">
                                <b>
                                  {total_Amount
                                    ?.toFixed(0)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </b>
                              </td>
                            </>
                          ) : (
                            /* saleTaxGroup == 0 -> collapse last two columns into one showing total_Amount */
                            <td className="text-right" colSpan="2">
                              <b>
                                {total_Amount
                                  ?.toFixed(0)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </b>
                            </td>
                          )}
                        </tr>
                      </tfoot>
                    </table>
                  )}
                </Col>

                {/* horizontal rule unchanged (keeps visual separation like before) */}
                <Col xs="12" className="">
                  <hr
                    style={{
                      border: "1px solid Light gray",
                    }}
                  />
                </Col>

                <br></br>
                {/* <Col xs="12" className=""> */}
                {this.state.dataExpReb?.length > 0 ? (
                  <table bordered style={{ width: "100%" }}>
                    <colgroup>
                      <col style={{ width: "25%" }} />
                      <col style={{ width: "15%" }} /> {/* Unit column */}
                      <col style={{ width: "15%" }} /> {/* Qty column */}
                      <col style={{ width: "15%" }} /> {/* Rate column */}
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "15%" }} />{" "}
                      {/* After Tax Amount column */}
                    </colgroup>

                    <thead>
                      <tr>
                        <th className="border">Tax/Char</th>
                        <th className="border">Tax/Char Code</th>
                        <th className="border">Charged To</th>
                        <th className="border text-right mr-1">
                          Charged To Code
                        </th>
                        <th className="border text-right">Narration</th>
                        <th className="border text-right mr-1">Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {this.state.dataExpReb?.map((itm, index) => (
                        <tr key={index}>
                          <td>
                            {itm.entry_type === "E" ? "Expense" : "Rebate"}
                          </td>
                          <td>{itm.exp_rgb_code_desc || ""}</td>
                          <td className="text-right">
                            {itm.charged_to === "S" ? "Supplier" : "Other"}
                          </td>
                          <td className="text-right mr-1">
                            {itm.chrgd_to_code_desc || ""}
                          </td>
                          <td className="text-right mr-2">
                            {itm.line_narration || ""}
                          </td>
                          <td className="text-right">
                            {itm.fc_amount
                              ?.toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </td>
                        </tr>
                      ))}
                    </tbody>

                    <tfoot>
                      <tr
                        style={{
                          fontWeight: "bold",
                          borderTop: "2px solid #000",
                        }}
                      >
                        <td className="text-center"></td>
                        <td className="text-right"></td>
                        <td className="text-right"></td>
                        <td className="text-right"></td>
                        <td className="text-right">Sub Total</td>
                        <td className="text-right">
                          {totalExpRebAmt != null
                            ? Math.round(totalExpRebAmt)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : ""}
                        </td>
                      </tr>

                      <tr
                        style={{
                          fontWeight: "bold",
                          borderTop: "2px solid #000",
                          borderBottom: "2px solid #000",
                        }}
                      >
                        <td className="text-center"></td>
                        <td className="text-right"></td>
                        <td className="text-right"></td>
                        <td className="text-right"></td>
                        <td className="text-right">Net Total</td>
                        <td className="text-right">
                          {invoiceTotal != null
                            ? Math.round(invoiceTotal)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : ""}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                ) : (
                  ""
                )}
                {/* </Col> */}

                <br></br>
                <br></br>
                <br></br>
                {/* <Col xs="10" className="">
                  <h4
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Payment Terms: Invoice to be settled by {dueDate}
                  </h4>
                </Col> */}
              </Row>
            </Col>

            {this.props?.authCheck ? null : (
              <Container
                className={`${
                  this.state.setNextPrintPageFooter
                    ? "footerNewPage"
                    : "footerPrint"
                }`}
                // className="footer"
                style={{ backgroundColor: "white" }}
              >
                <Row
                  className="mt-5 footerRows"
                  style={{
                    textAlign: "center",
                  }}
                >
                  {this.state.setFooterData.map((row) => (
                    <Col
                      lg="4"
                      md="4"
                      sm="4"
                      className="px-4"
                      style={{
                        marginBottom: "3rem",
                        marginTop: row.enteredBy != 1 ? "1.3rem" : "0",
                      }}
                    >
                      <h5>
                        {" "}
                        {row.enteredBy
                          ? row.enteredBy /*printData[0]?.name*/
                          : "  "}
                      </h5>
                      <hr
                        style={{
                          border: "1px solid ",
                          borderColor: "E4E5E6",
                          margin: "revert",
                        }}
                      />
                      <h4 key={row.id}>{row.desc}</h4>
                    </Col>
                  ))}
                </Row>
                <Row
                  className="print-footer-info mt-4"
                  style={{ fontSize: "12px", color: "#555" }}
                >
                  <Col xs="6" className="text-left">
                    <strong>Printed on:</strong> {currentDateTime}
                  </Col>
                  <Col xs="6" className="text-right">
                    <strong>Printed by:</strong> {userEmail}
                  </Col>
                </Row>
              </Container>
            )}
          </Row>
        </div>
      );
    } else {
      return (
        <div>
          <Row className="app-body-Invoice">
            <Col>
              <div
                className="col-md-12"
                style={{ width: "1100px", margin: "0 auto" }}
              >
                <div className="col-md-9">
                  <div className="row">
                    <div className="col-md-12">
                      <h2 style={{ fontWeight: "bold" }}>
                        <Redirect to={goBackUrl} />
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      );
    }
  }
}

export default PrintView;
